import {
  FETCH_ORDER_BY_TOKEN_FAILURE,
  FETCH_ORDER_BY_TOKEN_REQUEST,
  FETCH_ORDER_BY_TOKEN_SUCCESS,
} from 'constants/index';

export const fetchOrder =
  ({ token }) =>
  async (dispatch, _getState, { orders }) => {
    dispatch({ type: FETCH_ORDER_BY_TOKEN_REQUEST });

    try {
      const { fetch } = orders;
      const response = await fetch({ token });
      dispatch({ type: FETCH_ORDER_BY_TOKEN_SUCCESS, payload: response });
    } catch (_error) {
      dispatch({ type: FETCH_ORDER_BY_TOKEN_FAILURE });
    }
  };
